/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { UserModel } from './UserModel';
import {
    UserModelFromJSON,
    UserModelFromJSONTyped,
    UserModelToJSON,
} from './UserModel';

/**
 * ランキングの作品一覧を戻されます。
 * @export
 * @interface RankingSeriesModel
 */
export interface RankingSeriesModel {
    /**
     * 作品のID
     * @type {string}
     * @memberof RankingSeriesModel
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RankingSeriesModel
     */
    indexId?: number;
    /**
     * 作品のタイトル
     * @type {string}
     * @memberof RankingSeriesModel
     */
    title: string;
    /**
     * 
     * @type {ImageModel}
     * @memberof RankingSeriesModel
     */
    image?: ImageModel;
    /**
     * 
     * @type {Array<UserModel>}
     * @memberof RankingSeriesModel
     */
    author?: Array<UserModel>;
    /**
     * 
     * @type {UserModel}
     * @memberof RankingSeriesModel
     */
    publisher?: UserModel;
    /**
     * 
     * @type {Array<UserModel>}
     * @memberof RankingSeriesModel
     */
    collaborators?: Array<UserModel>;
    /**
     * 作品のリンク
     * @type {string}
     * @memberof RankingSeriesModel
     */
    url: string;
    /**
     * 「更新」の右上の帯
     * @type {boolean}
     * @memberof RankingSeriesModel
     */
    isUp?: boolean;
    /**
     * true の場合、キャンペーン中であることを表します
     * @type {boolean}
     * @memberof RankingSeriesModel
     */
    isOnCampaign?: boolean;
    /**
     * キャンペーン終了時刻のUNIX時間
     * @type {number}
     * @memberof RankingSeriesModel
     */
    campaignEndDatetime?: number;
    /**
     * 無料話数
     * @type {number}
     * @memberof RankingSeriesModel
     */
    freeArticleCount?: number;
    /**
     * 待つと無料が始まるエピソードのインデックス
     * @type {number}
     * @memberof RankingSeriesModel
     */
    waitFreeStartArticleIndex?: number;
    /**
     * 待つと無料が終わるエピソードのインデックス
     * @type {number}
     * @memberof RankingSeriesModel
     */
    waitFreeEndArticleIndex?: number;
}

/**
 * Check if a given object implements the RankingSeriesModel interface.
 */
export function instanceOfRankingSeriesModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function RankingSeriesModelFromJSON(json: any): RankingSeriesModel {
    return RankingSeriesModelFromJSONTyped(json, false);
}

export function RankingSeriesModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankingSeriesModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'indexId': !exists(json, 'indexId') ? undefined : json['indexId'],
        'title': json['title'],
        'image': !exists(json, 'image') ? undefined : ImageModelFromJSON(json['image']),
        'author': !exists(json, 'author') ? undefined : ((json['author'] as Array<any>).map(UserModelFromJSON)),
        'publisher': !exists(json, 'publisher') ? undefined : UserModelFromJSON(json['publisher']),
        'collaborators': !exists(json, 'collaborators') ? undefined : ((json['collaborators'] as Array<any>).map(UserModelFromJSON)),
        'url': json['url'],
        'isUp': !exists(json, 'isUp') ? undefined : json['isUp'],
        'isOnCampaign': !exists(json, 'isOnCampaign') ? undefined : json['isOnCampaign'],
        'campaignEndDatetime': !exists(json, 'campaignEndDatetime') ? undefined : json['campaignEndDatetime'],
        'freeArticleCount': !exists(json, 'freeArticleCount') ? undefined : json['freeArticleCount'],
        'waitFreeStartArticleIndex': !exists(json, 'waitFreeStartArticleIndex') ? undefined : json['waitFreeStartArticleIndex'],
        'waitFreeEndArticleIndex': !exists(json, 'waitFreeEndArticleIndex') ? undefined : json['waitFreeEndArticleIndex'],
    };
}

export function RankingSeriesModelToJSON(value?: RankingSeriesModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'indexId': value.indexId,
        'title': value.title,
        'image': ImageModelToJSON(value.image),
        'author': value.author === undefined ? undefined : ((value.author as Array<any>).map(UserModelToJSON)),
        'publisher': UserModelToJSON(value.publisher),
        'collaborators': value.collaborators === undefined ? undefined : ((value.collaborators as Array<any>).map(UserModelToJSON)),
        'url': value.url,
        'isUp': value.isUp,
        'isOnCampaign': value.isOnCampaign,
        'campaignEndDatetime': value.campaignEndDatetime,
        'freeArticleCount': value.freeArticleCount,
        'waitFreeStartArticleIndex': value.waitFreeStartArticleIndex,
        'waitFreeEndArticleIndex': value.waitFreeEndArticleIndex,
    };
}

